import { useCallback, useEffect, useState } from 'react';
import { api } from './api';

export function useRemote<T>(path: string | null, refreshMs = 0) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(Boolean(path));
  const load = useCallback(async (showLoading = true) => {
    if (!path) return;
    if (showLoading) setLoading(true);
    setError('');
    try { setData(await api.get<T>(path)); }
    catch (cause) { setError(cause instanceof Error ? cause.message : '读取失败'); }
    finally { setLoading(false); }
  }, [path]);
  useEffect(() => {
    void load();
    if (!refreshMs) return;
    const timer = window.setInterval(() => void load(false), refreshMs);
    return () => window.clearInterval(timer);
  }, [load, refreshMs]);
  return { data, error, loading, reload: () => load(), setData };
}
